// extracted by mini-css-extract-plugin
export default {"customIcon":"CustomIcon_customIcon__cG34s","icomoonIcon":"CustomIcon_icomoonIcon__t0tYQ"};